import React from 'react';
import createStyles from '@material-ui/core/styles/createStyles';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { Theme, SvgIconProps as MuiSvgIconProps, SvgIcon as MuiSvgIcon } from '@material-ui/core';
import { EdwardColors } from 'enums';

const DEFAULT_HTML_COLOR = EdwardColors.DARK;

const useStyles = makeStyles<Theme, SvgIconProps>(() =>
  createStyles({
    bg: {
      fill: (props) =>
        props.transparentBgr
          ? 'none'
          : props.invert
          ? props.htmlColor || DEFAULT_HTML_COLOR
          : '#fff',
    },
    contents: (props) => ({
      fill: props.defaultFill ? undefined : 'none',
      stroke: props.defaultStroke ? undefined : props.invert ? '#fff' : props.htmlColor || DEFAULT_HTML_COLOR,
      //strokeWidth: props.strokeWidth !== undefined ? props.strokeWidth : 2,
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
      strokeMiterlimit: 10,

      '& .filled': {
        fill:
          props.invert ? '#fff' : props.htmlColor || DEFAULT_HTML_COLOR,
      },
    }),
  }),
);

export interface SvgIconProps extends MuiSvgIconProps {
  invert?: boolean;
  strokeWidth?: number;
  transparentBgr?: boolean;
  defaultFill?: boolean;
  defaultStroke?: boolean;
}

const SvgIcon: React.FC<SvgIconProps> = ({ children, ...other }) => {
  const classes = useStyles(other);
  const w = 56.69;
  const h = w;
  const filteredProps = { ...other };
  delete filteredProps.invert;
  delete filteredProps.transparentBgr;
  delete filteredProps.defaultFill;
  delete filteredProps.defaultStroke;

  return (
    <MuiSvgIcon viewBox={`0 0 ${w} ${h}`} {...filteredProps}>
      <rect className={classes.bg} width={w} height={h} />
      <g className={classes.contents}>{children}</g>
    </MuiSvgIcon>
  );
};

export default SvgIcon;
